import { parseLRC } from '../utils/lrcParser';

// Кэш для распарсенных файлов
const parsedLrcCache = {};

// Индексация URL-адресов всех .lrc файлов
let LRC_URLS = {};
try {
    const lrcContext = require.context('../assets/music', false, /\.lrc$/);
    lrcContext.keys().forEach(key => {
        const fileName = key.split('/').pop().split('.')[0];
        // Очищаем имя от хешей Webpack, чтобы оно совпадало с именем mp3
        const cleanName = decodeURIComponent(fileName).replace(/\.[a-f0-9]{8,20}$/, '');
        LRC_URLS[cleanName] = lrcContext(key);
    });
} catch (e) {
    console.warn("KaraokeConfig: LRC files indexing failed", e);
}

/**
 * Возвращает URL LRC-файла для трека
 */
export const getLrcUrlForTrack = (trackName) => {
    return LRC_URLS[trackName] || null;
};

export const getLyricsForTrack = (trackName) => {
    // Этот метод теперь используется как фолбек или для кэша
    if (parsedLrcCache[trackName]) return parsedLrcCache[trackName];
    return [];
};

/**
 * Сохраняет распарсенные данные в кэш
 */
export const cacheParsedLyrics = (trackName, lyrics) => {
    parsedLrcCache[trackName] = lyrics;
};

// Экспортируем для совместимости (если нужно)
export const karaokeLyrics = {};
